var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaymentM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 9.63H7a3 3 0 00-3 3v14.75a3 3 0 003 3h26a3 3 0 003-3V12.63a3 3 0 00-3-3zm-26 2h26a1 1 0 011 1V14H6v-1.37a1 1 0 011-1zm26 16.75H7a1 1 0 01-1-1V16h28v11.38a1 1 0 01-1 1zM32 26h-8v-4h8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0z"
  })));
}

export default SvgIconPaymentM;